import { useState, useEffect } from "react";

export const DiscountTimer = ({ discount }) => {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    const key = "discount_timer_global";
    let endTime = localStorage.getItem(key);
    if (!endTime) {
      endTime = Date.now() + 48 * 60 * 60 * 1000;
      localStorage.setItem(key, endTime.toString());
    }
    endTime = Number(endTime);

    const update = () => {
      const diff = endTime - Date.now();
      if (diff <= 0) {
        setTimeLeft({ h: 0, m: 0, s: 0 });
      } else {
        setTimeLeft({
          h: Math.floor(diff / 3600000),
          m: Math.floor((diff % 3600000) / 60000),
          s: Math.floor((diff % 60000) / 1000)
        });
      }
    };

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!timeLeft) return null;

  const pad = (n) => String(n).padStart(2, "0");

  return (
    <span className="font-mono font-bold tabular-nums">
      {pad(timeLeft.h)}:{pad(timeLeft.m)}:{pad(timeLeft.s)}
    </span>
  );
};

export const DiscountRibbon = ({ discount }) => {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    const key = "discount_timer_global";
    let endTime = localStorage.getItem(key);
    if (!endTime) {
      endTime = Date.now() + 48 * 60 * 60 * 1000;
      localStorage.setItem(key, endTime.toString());
    }
    endTime = Number(endTime);

    const update = () => {
      const diff = endTime - Date.now();
      if (diff <= 0) {
        setTimeLeft({ h: 0, m: 0, s: 0 });
      } else {
        setTimeLeft({
          h: Math.floor(diff / 3600000),
          m: Math.floor((diff % 3600000) / 60000),
          s: Math.floor((diff % 60000) / 1000)
        });
      }
    };

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!timeLeft) return null;

  const pad = (n) => String(n).padStart(2, "0");
  
  const RibbonText = () => (
    <span className="flex items-center gap-2 whitespace-nowrap px-4">
      <span className="text-rose-400 font-semibold text-xs">Скидка</span>
      <span className="text-rose-400 font-bold text-sm">-{discount}%</span>
      <span className="text-gray-500 text-xs">·</span>
      <span className="text-gray-300 text-xs">Осталось</span>
      <span className="text-white font-mono font-bold text-sm tabular-nums">
        {pad(timeLeft.h)}:{pad(timeLeft.m)}:{pad(timeLeft.s)}
      </span>
    </span>
  );

  return (
    <div 
      className="absolute z-10"
      style={{ right: '-120px', bottom: '-20px' }}
      data-testid="discount-ribbon"
    >
      <div 
        className="bg-[#E8D8CB] py-2 overflow-hidden"
        style={{
          width: '650px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
          transform: 'rotate(-45deg)'
        }}
      >
        <div 
          className="flex animate-marquee"
          style={{
            animation: 'marquee 10s linear infinite'
          }}
        >
          <RibbonText />
          <RibbonText />
          <RibbonText />
          <RibbonText />
        </div>
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
};
